import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useRecentSearchesSection } from '../sections/recent-search-section';

/**
 * This component injects recent searches section into pre query items.
 */
export var RecentSearchesTransformer = function RecentSearchesTransformer(_ref) {
  var preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  var recentSearchesSection = useRecentSearchesSection();
  var preQueryItemsWithRecentSearches = {
    sections: [recentSearchesSection].concat(_toConsumableArray(preQueryItems.sections)),
    size: preQueryItems.size
  };
  return children({
    preQueryItems: preQueryItemsWithRecentSearches,
    postQueryItems: postQueryItems,
    productState: productState
  });
};